import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef, } from 'react';
import '../../styles/game/InfoBoard.css';
import '../../styles/game/InfoBoardTabs.css';
import '../../styles/game/InfoBoardComponents.css';
import { t } from "i18next";
import { useData, useSocket } from '../../providers/SocketContext.jsx'
import { useAuth } from '../../providers/AuthProvider.jsx';






function AllBetsTitle() {
    const { user } = useAuth()
    const socket = useSocket()

    const [singlePlayersCount, setSinglePlayersCount] = useState(0)
    const [doublePlayersCount, setDoublePlayersCount] = useState(0)
    const [totalPlayersCount, setTotalPlayersCount] = useState(0)
    const [progressBarWidth, setProgressBarWidth] = useState(0)
    const [totalWin, setTotalWin] = useState(0)
    const [mainWallet, setMainWallet] = useState(null)
    const [playersAvatar, setPLayersAvatar] = useState([5, 15, 23])

    useEffect(() => {
      if(!user) {
        return
      }
      setMainWallet(user.mainWallet)
      
    }, [user])


    useEffect(() => {
      if (!socket) {
        return;
      }
  
      const handleTotalBetPlayers = (singlePlayers, doublePlayers, totalPlayers) => {

        setSinglePlayersCount(parseFloat(singlePlayers));
        setDoublePlayersCount(parseFloat(doublePlayers));
        setTotalPlayersCount(parseFloat(totalPlayers))
        
      };
  
      socket.on('get_total_bet_players', handleTotalBetPlayers);
  
      return () => {
        socket.off('get_total_bet_players', handleTotalBetPlayers);
      };
    }, [socket]);

    useEffect(() => {
      if(!socket) {
        return
      }

      socket.emit('getSingleDouble')
      socket.on('SingleDouble', (obj) => {
        
        setSinglePlayersCount(parseFloat(obj.singlePlayers));
        setDoublePlayersCount(parseFloat(obj.doublePlayers));
        setTotalPlayersCount(parseFloat(obj.totalPlayers));

      })

      return () => {
        socket.off('SingleDouble', (obj) => {
          setSinglePlayersCount(parseFloat(obj.singlePlayers));
          setDoublePlayersCount(parseFloat(obj.doublePlayers));
        })
      }
    }, [socket])

    useEffect(() => {
      if(!socket) {
        return
      }

      socket.on('single_double_players_update', (res) => {
        setSinglePlayersCount(res.singlePlayers)
        setDoublePlayersCount(res.doublePlayers)
      })
      socket.on('players_avatar_emit_gameboard', (res) => {
        setPLayersAvatar(res)
    })

      return () => {
        socket.off('single_double_players_update', (res) => {
          setSinglePlayersCount(res.singlePlayers)
          setDoublePlayersCount(res.doublePlayers)
        })
        socket.off('players_avatar_emit_gameboard', (res) => {
          setPLayersAvatar(res)
      })
      }
    }, [socket])

    useEffect(() => {
        if(totalPlayersCount === 0) {
            setProgressBarWidth(0)
        } else {
            setProgressBarWidth(() => {
              let percent = totalPlayersCount / 100
              let result = (singlePlayersCount + doublePlayersCount) / percent
              return 100 - result
            })
            // setProgressBarWidth(((singlePlayersCount + doublePlayersCount) / totalPlayersCount) * 100)

        }
        
        
    }, [singlePlayersCount])

    useEffect(() => {
      if(!socket) {
        return
      }

      const uzs = 13000.25;
      const rub = 100.71
      const usd = 1;

      socket.on('players_total_win', (res) => {
        if(mainWallet) {
          if(mainWallet === 'uzs') {
            setTotalWin(parseFloat(res) * uzs)
          } else if (mainWallet === 'rub') {
            setTotalWin(parseFloat(res) * rub)
          } else {
            setTotalWin(parseFloat(res) * usd)
          }
        }
      })

      socket.on('countdown_total_win', (res) => {
        if(mainWallet) {
          if(mainWallet === 'uzs') {
            setTotalWin(parseFloat(res) * uzs)
          } else if (mainWallet === 'rub') {
            setTotalWin(parseFloat(res) * rub)
          } else {
            setTotalWin(parseFloat(res) * usd)
          }
        }
      })

      return () => {
        socket.off('players_total_win', (res) => {
          if(mainWallet) {
            if(mainWallet === 'uzs') {
              setTotalWin(parseFloat(res) * uzs)
            } else if (mainWallet === 'rub') {
              setTotalWin(parseFloat(res) * rub)
            } else {
              setTotalWin(parseFloat(res) * usd)
            }
          }
        })

        socket.off('countdown_total_win', (res) => {
          if(mainWallet) {
            if(mainWallet === 'uzs') {
              setTotalWin(parseFloat(res) * uzs)
            } else if (mainWallet === 'rub') {
              setTotalWin(parseFloat(res) * rub)
            } else {
              setTotalWin(parseFloat(res) * usd)
            }
          }
        })
      }
    }, [socket, mainWallet])


    return (
      <div className={'all-bets-block-title-wrap'}>
        <div className={'all-bets-block-title-header'}>
          <div className={'all-bets-block-header-avatars'}>
            <div className={'all-bets-block-avatars-wrap'}>
                <img className={'all-bets-block-avatar-wrap-1'} src={`/assets/img/avatars/av-${playersAvatar[0]}.png`} alt="" />
                <img className={'all-bets-block-avatar-wrap-2'} src={`/assets/img/avatars/av-${playersAvatar[1]}.png`} alt="" />
                <img className={'all-bets-block-avatar-wrap-3'} src={`/assets/img/avatars/av-${playersAvatar[2]}.png`} alt="" />

            </div>
          </div>
          <div className={'all-bets-block-header-cashout'}>
            {parseFloat(totalWin).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
})}
          </div>
        </div>
        <div className={'all-bets-block-stats'}>
          <div className={'all-bets-block-bets-count'}>
            <span>{singlePlayersCount ? parseFloat(singlePlayersCount + doublePlayersCount).toFixed(0) : "0"}/{totalPlayersCount ? parseFloat(totalPlayersCount).toFixed(0) : "0"}</span>
            <p>{t("infoboard_bet")}</p>
          </div>
          <div className={'all-bets-block-total-win'}>{t("totalWin")} UZS</div>
        </div>
        <div className={'all-bets-block-progress'}>
          <div className={'all-bets-block-progress-bar'} style={{"width": `${progressBarWidth}%`}}></div>
        </div>
      </div>
    )
  }

  export default AllBetsTitle;